import useRidesStore from '../stores/rides'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { retrieveRide } from '../services/create-ride/api'
import useRidesKeys from './useRidesKeys'
const useRideByIdQuery = () => {
  const ridesKeys = useRidesKeys()
  const queryClient = useQueryClient()
  const selectedRideId = useRidesStore(state => state.selectedRideId)

  return useQuery({
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    queryKey: ['ride', selectedRideId],
    queryFn: async () => {
      if (!selectedRideId) return null
      const rides = await retrieveRide(selectedRideId)
      queryClient.setQueryData(ridesKeys, (oldData: any) => {
        const newRides = oldData?.rides.data.map((ride: any) => ride.id === selectedRideId ? rides.ride : ride)

        return {
          ...oldData,
          rides: {
            ...oldData?.rides,
            data: newRides
          }
        }
      })
      return rides
    }
  })
}

export default useRideByIdQuery
